import React from 'react';

import useIsMobile from 'hooks/use-is-mobile';
import ContentCard from 'pages/Landings/components/ContentCard';
import Customers from 'pages/Landings/components/Customers';
import EmailLink from 'pages/Landings/components/EmailLink';
import Layout from 'pages/Landings/components/Layout';
import Title from 'pages/Landings/components/Title';

import ceoImage from './assets/ceo.png?file';
import coFounderImage from './assets/co-founder.png?file';
import headOfRevenueImage from './assets/head-of-revenue.png?file';
import Promo from './components/Promo';
import Requisites from './components/Requisites';
import useStyles from './styles';

const AboutUs: React.FC = () => {
    const { classes } = useStyles();
    const isMobile = useIsMobile();
    return (
        <Layout>
            <div className={classes.container}>
                <Title variant={isMobile ? 'h1' : 'h2'} as={'h1'} className={classes.title}>
                    {'About Us'}
                </Title>
                <p className={classes.subtitle}>
                    {
                        'Our mission to help security teams instantly receive the most accurate and complete information about new vulnerabilities and threats emerging in the world'
                    }
                </p>
                <div className={classes.sections}>
                    <ContentCard
                        picture={<img src={ceoImage} className={classes.image} />}
                        title={'Kir Ermakov, СЕО & founder'}
                        subtitle={
                            <>
                                {'15+ years of experience in cybersecurity'}
                                <br />
                                {
                                    'At Vulners,  actively involved in day-to-day operations – R&D, sales, PR, and marketing'
                                }
                            </>
                        }
                        actions={<EmailLink email="isox@vulners.com" />}
                        className={classes.ceo}
                    />
                    <ContentCard
                        picture={<img src={coFounderImage} className={classes.image} />}
                        title={'Ivan Elkin, co-founder'}
                        subtitle={
                            <>
                                {'Application security team lead, pentester, full-stack developer'}
                                <br />
                                {'At Vulners, leads frontend and integrations development'}
                            </>
                        }
                        actions={<EmailLink email="vankyver@vulners.com" />}
                        className={classes.coFounder}
                    />
                    <ContentCard
                        picture={<img src={headOfRevenueImage} className={classes.image} />}
                        title={'Andrey Lukashenkov, head of revenue'}
                        subtitle={
                            <>
                                {'20+ years of experience in technology sales'}
                                <br />
                                {
                                    'At Vulners, responsible for all things Go to Market, including marketing, sales, and customer success'
                                }
                            </>
                        }
                        actions={<EmailLink email="la@vulners.com" />}
                        className={classes.headOfRevenue}
                    />
                    <ContentCard
                        picture={<span className={classes.letterAvatar}>{'10+'}</span>}
                        title={'Other team members'}
                        subtitle={
                            <ul>
                                <li>{'Frontend developers'}</li>
                                <li>{'Backend developers'}</li>
                                <li>{'Integrations developer'}</li>
                                <li>{'DevOps'}</li>
                                <li>{'Product designer'}</li>
                            </ul>
                        }
                        className={classes.others}
                    />
                    <Promo className={classes.promo} />
                    <Requisites className={classes.requisites} />
                </div>
            </div>
            <Customers className={classes.customers} />
        </Layout>
    );
};

export default AboutUs;
